export default "__VITE_ASSET__be2191cb__"